var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"local-wrapper",style:({
      background: _vm.slideData.background_color,
      color: _vm.slideData.text_color,
    })},[(_vm.slideData.include_copy)?_c('div',{staticClass:"local-description-box",domProps:{"innerHTML":_vm._s(_vm.slideData.slide_text)}}):_vm._e()])])}
var staticRenderFns = []

export { render, staticRenderFns }